// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__27fSx","footer":"ModalUpdate_footer__17EUZ"};